import axios from 'axios'

const fetchUsers = async filter => {
  const url = `/api/v1/honeyUsers${filter ? filter : ''}`
  return await axios.get(url)
}

const fetchUser = async hexId => {
  const url = `/api/v1/honeyUsers/${hexId}`
  return await axios.get(url)
}

const deleteUser = async hexId => {
  return await axios.delete(`/api/v1/honeyUsers/${hexId}`)
}

const fetchHoneyUserHoneyRoles = async honeyUser => {
  const { data } = await axios.get(
    `/api/v1/honeyUsers/${honeyUser.hexId}/honeyRoles`
  )
  return data._embedded.honeyRoles
}

const addHoneyRoleToHoneyUser = async (honeyRoles, honeyUser) => {
  let data = honeyRoles
    .map(honeyRole => {
      return `/api/v1/honeyRoles/${honeyRole.hexId}`
    })
    .join('\n')
  let response = await axios.post(
    `/api/v1/honeyUsers/${honeyUser.hexId}/honeyRoles`,
    data,
    {
      headers: {
        'Content-Type': 'text/uri-list'
      }
    }
  )
  return response.data
}

const deleteHoneyRoleFromHoneyUser = (honeyRoles, honeyUser) => {
  return Promise.all(
    honeyRoles.map(honeyRole => {
      return axios.delete(
        `/api/v1/honeyUsers/${honeyUser.hexId}/honeyRoles/${honeyRole.hexId}`
      )
    })
  )
}

export default {
  fetchUsers,
  deleteUser,
  fetchUser,
  fetchHoneyUserHoneyRoles,
  addHoneyRoleToHoneyUser,
  deleteHoneyRoleFromHoneyUser
}
